import { ParticipantMarketType } from '@cds/betting-offer';

import { BetslipV1Pick } from '../../../../../core/picks/betslip-v1-pick';
import { BetslipV2OptionMarketXCastRacePick } from '../../../../../core/picks/sport-specific/betslip-v2-horse-race-picks';
import { BaseComboPrevention } from './combo-prevention';
import { ComboPreventionResult } from './combo-prevention-result.enum';

/**
 * Validates V2 participant picks and V1 general pick for combo.
 */
export class V2OptionMarketXCastV1SportComboPrevention extends BaseComboPrevention<BetslipV2OptionMarketXCastRacePick, BetslipV1Pick> {
    constructor() {
        super(BetslipV2OptionMarketXCastRacePick, BetslipV1Pick);
    }

    validate(thisPick: BetslipV2OptionMarketXCastRacePick, otherPick: BetslipV1Pick, isSystemBet: boolean): ComboPreventionResult {
        if (thisPick.market.marketType === ParticipantMarketType.Forecast || thisPick.market.marketType === ParticipantMarketType.Tricast) {
            // Can not combine sport with Forecast or tricast races.
            return ComboPreventionResult.XCastWithSport;
        }

        return ComboPreventionResult.AllCombo;
    }
}
